<template>
  <div class="search-input-box" :style="{ width: width }">
    <van-icon name="search" size="20" style="vertical-align: middle;" color="#b5b5b5" />
    <!-- $listeners将所有的事件监听器指向这个组件的某个特定的子元素 -->
    <input type="text" v-model="inputValue" @input="getInput" v-on='$listeners' class="search-input" :placeholder="placeholder" />
    <van-icon
      name="cross"
      size="12"
      style="vertical-align: middle;"
      color="#b5b5b5"
      v-show="inputValue.length > 0"
      @click="clearName"
    />
  </div>
</template>

<script>
export default {
  props: {
    input:{
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: '60vw',
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  created() {
    this.inputValue = this.input;
  },
  methods: {
    //清空搜索框
    clearName() {
      this.inputValue = '';
      this.$emit('update:input',this.inputValue)
    },
    getInput() {
      this.$emit('update:input',this.inputValue)
    },
  },
};
</script>

<style scoped lang="scss">
.search-input-box {
  display: inline-block;
  height: 29px;
  padding: 0 10px;
  line-height: 29px;
  border-radius: 20px;
  background: #f6f6f6;
  vertical-align: text-bottom;
  font-size: 12px;
  .search-input {
    display: inline-block;
    width: calc(100% - 50px);
    outline: none;
    border: none;
    background: #f6f6f6;
    margin-left: 10px;
    vertical-align: initial;
  }
}
</style>
